<template>
  <v-form
    @submit="onSubmit"
    :action="this.server + this.$route.path"
    ref="form"
    id="form-contact"
    v-model="valid"
    lazy-validation
  >
    <v-text-field
      dense
      outlined
      name="name"
      :rules="nameRules"
      label="Nome"
      required
    ></v-text-field>

    <v-text-field
      dense
      outlined
      name="tel"
      :rules="telRules"
      label="Telefone"
      required
      v-mask="['(##) ####-####', '(##) #####-####']"
    ></v-text-field>

    <template v-if="vacancies.length">
      <v-select
        dense
        outlined
        name="vacancies"
        v-model="selectedVacancy"
        :rules="vacanciesRules"
        :items="vacancies"
        label="Vaga"
        required
      ></v-select>
    </template>

    <v-file-input
      :rules="attachmentRules"
      color="primary"
      name="attachment"
      label="Anexar currículo"
      background-color="white"
      accept=".doc,.docx,application/msword,application/pdf"
      outlined
      dense
    ></v-file-input>

    <v-checkbox
      name="policy_privacy"
      v-model="policy_privacy"
      :rules="[(v) => !!v || 'Você precisa aceitar para continuar.']"
      required
      value="1"
      class="mt-0 policy-privacy"
    >
      <template v-slot:label>
        <div>
          Eu li e concordo com a
          <a class="primary--text" @click="showPrivacy">
            Política de Privacidade.
          </a>
        </div>
      </template>
    </v-checkbox>

    <div class="text-center">
      <v-btn
        color="primary"
        :loading="loadingForm"
        class="text-h6 primary white--text text-none px-8 mt-2"
        type="submit"
        height="40px"
        depressed
        rounded
      >
        Enviar
      </v-btn>
    </div>

    <v-snackbar :color="color" centered v-model="snackbar" :multi-line="true">
      <span>
        {{ response }}
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false" icon>
          <v-icon> fa fa-times </v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-form>
</template>

<script>
import { mask } from "vue-the-mask";
import { telTest } from "../../utils/telTest";

export default {
  data: () => ({
    response: "",
    color: "success",
    loadingForm: false,
    snackbar: false,
    valid: true,
    nameRules: [(v) => !!v || "Digite seu nome."],
    telRules: [
      (v) => !!v || "Digite seu telefone.",
      (v) => telTest(v) || "Digite um telefone válido",
    ],
    vacanciesRules: [(v) => !!v || "Selecione uma vaga."],
    attachmentRules: [(v) => !!v || "É preciso anexar um arquivo."],
    policy_privacy: false,
  }),
  created() {
    this.$rest("vacancies").get();
  },
  computed: {
    vacancies() {
      return this.$rest("vacancies").list.map(({ id, title }) => ({
        text: title,
        value: id,
      }));
    },
    selectedVacancy: {
      get() {
        const b = this.$route.query.vaga;
        return b ? Number(b) : "";
      },
      set(v) {
        const query = { ...this.query };
        if (v.length) query.vaga = v.join();
        else delete query.vaga;

        this.$router.push({ path: "/trabalhe-conosco", query });
      },
    },
  },
  methods: {
    showPrivacy: () => window.showPrivacyPolicy(),
    onSubmit(event) {
      const form = document.getElementById("form-contact");

      if (this.$refs.form.validate()) {
        this.loadingForm = true;

        const formData = new FormData(form);
        const action = `${this.server}/rest/email/work-with-us`;

        fetch(action, {
          method: "POST",
          body: formData,
        })
          .then((r) => {
            if (r.ok) {
              location = "/trabalhe-conosco/obrigado";
            } else {
              this.response =
                "OPS! tivemos um problema no envio das informações, tente novamente mais tarde.";
              this.color = "red accent-2";
              this.snackbar = true;
              this.loadingForm = false;
            }
          })
          .catch(() => {
            this.response =
              "OPS! tivemos um problema no envio das informações, tente novamente mais tarde.";
            this.color = "red accent-2";
            this.snackbar = true;
            this.loadingForm = false;
          });
      }

      event.preventDefault();
    },
  },
  directives: {
    mask,
  },
};
</script>
